import { render } from "./weekCalendar.vue?vue&type=template&id=a0990c22&scoped=true"
import script from "./weekCalendar.vue?vue&type=script&lang=js"
export * from "./weekCalendar.vue?vue&type=script&lang=js"

import "./weekCalendar.vue?vue&type=style&index=0&id=a0990c22&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0990c22"]])

export default __exports__